var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rules"},[_c('h1',{staticClass:"title"},[_vm._v("RULES")]),_c('img',{staticClass:"image",attrs:{"src":require("@/assets/image-rules-bonus.svg"),"alt":"Game rules"}}),_c('BackButton')],1)}
var staticRenderFns = []

export { render, staticRenderFns }